import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { CircularProgress, Box } from "@mui/material";

import { feedActions } from "../../../../reducers/feed";

import TableBody from "../TableBody";
import TableHeader from "../TableHeader";
import { PaginationWithLimit } from "../../../../components/ui";

import { APIBilling } from "../../../../api";
import { useFeedContext } from "../../../../context";
import { StyledTable } from "../../../../useGeneralStyles";

interface IProps {
  groupBy: string;
  inputProps?: {
    max: number;
  };
}
const PaymentsByCategory = ({ groupBy, inputProps }: IProps): React.ReactElement => {
  const dispatch = useDispatch();
  const { sortBy, search, page, setPage, limit, setLimit } = useFeedContext();

  const [isFetchError, setIsFetchError] = useState(false);

  const { loading, payments, count } = useSelector((state) => state.feed.data.failedPayments);

  useEffect(() => {
    dispatch(feedActions.fetchFailedPaymentsRequest());

    (async () => {
      try {
        const response = await APIBilling.getBillingStatusesRequest({
          page,
          limit,
          sortBy,
          contains: search,
          groupBy,
        });
        const { data } = response;
        dispatch(feedActions.fetchFailedPaymentsSuccess(data));
      } catch (error) {
        setIsFetchError(true);
        dispatch(feedActions.fetchFailedPaymentsFailed());
      }
    })();
  }, [dispatch, limit, page, search, sortBy, groupBy]);

  return (
    <div>
      <StyledTable>
        <TableHeader groupBy={groupBy} />
        {!loading && <TableBody groupBy={groupBy} />}
      </StyledTable>

      {loading && (
        <Box sx={{ display: "flex", justifyContent: "center" }}>
          <CircularProgress
            sx={{
              marginTop: "10px",
              color: "#1886cf",
            }}
          />
        </Box>
      )}
      {!loading && !payments.length && !isFetchError && (
        <Box sx={{ marginTop: "10px", display: "flex", justifyContent: "center" }}>
          <span>No results</span>
        </Box>
      )}

      {isFetchError && (
        <Box sx={{ marginTop: "10px", display: "flex", justifyContent: "center" }}>
          <span>There was a problem retrieving info from Stripe</span>
        </Box>
      )}

      <PaginationWithLimit
        inputProps={inputProps}
        count={count}
        limit={limit}
        setLimit={setLimit}
        page={page}
        setPageState={setPage}
      />
    </div>
  );
};

export default PaymentsByCategory;
